import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import SecurityIcon from "@material-ui/icons/Security";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import authApi from "api/authApi";
import { useAppSelector } from "app/hooks";
import InputField from "components/FormFields/InputField";
import { selectInfoLogin } from "features/Auth/authSlice";
import { ChangePasswordProps } from "models/auth";
import { ResponseStatus } from "models/common";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as yup from "yup";
import useStyles from "../style";

export default function ChangePassword() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const { t } = useTranslation();

  const schema = yup.object().shape({
    currentPassword: yup.string().required(`${t("profile.vuilongnhapmatkhauhientai") || "Vui lòng nhập mật khẩu hiện tại"}`),
    newPassword: yup.string().required(`${t("profile.vuilongnhapmatkhaumoi") || "Vui lòng nhập mật khẩu mới"}`),
    confirmNewPassword: yup
      .string()
      .required(`${t("profile.vuilongnhapmatkhaumoi") || "Vui lòng xác nhận mật khẩu mới"}`)
      .oneOf([yup.ref("newPassword"), null], `${t("profile.matkhaukhongtrungkhop") || "Mật khẩu không trùng khớp"}`),
  });

  const infoLogin = useAppSelector(selectInfoLogin);

  const initialValues: ChangePasswordProps = {
    currentPassword: "",
    confirmNewPassword: "",
    newPassword: "",
  };

  const { control, handleSubmit, reset } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleSubmitForm = async (value: ChangePasswordProps) => {
    setDisabledSubmit(true);
    try {
      const res: ResponseStatus = await authApi.changePassword(value);
      setDisabledSubmit(false);
      if (res.responseCode === "00") {
        toast.success(`${t("profile.doimatkhauthanhcong") || "Đổi mật khẩu thành công!"}`);
        reset();
      } else {
        setDisabledSubmit(false);
        toast.error(`${t("profile.matkhauhientaikhongdung") || "Mật khẩu hiện tại không đúng!"}`);
        throw new Error(`${t("profile.matkhauhientaikhongdung")}`);
      }
    } catch (error) {}
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitForm)} className={classes.formContainer} style={{ position: "relative" }}>
      {loading && (
        <Box className={classes.loading}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress style={{ width: 44, height: 44, color: "#4F46E5" }} />
          </Box>
        </Box>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box className={classes.fieldGroup}>
            <Typography className={classes.formLabel}>
              <LockIcon style={{ fontSize: 18, color: "#4F46E5" }} />
              {t("profile.matkhauhientai") || "MẬT KHẨU HIỆN TẠI"}
            </Typography>
            <InputField
              name="currentPassword"
              inputType="password"
              label={t("profile.matkhauhientai") || "Nhập mật khẩu hiện tại"}
              control={control}
              borderRadius="12px"
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box className={classes.fieldGroup}>
            <Typography className={classes.formLabel}>
              <VpnKeyIcon style={{ fontSize: 18, color: "#4F46E5" }} />
              {t("profile.matkhaumoi") || "MẬT KHẨU MỚI"}
            </Typography>
            <InputField
              name="newPassword"
              inputType="password"
              label={t("profile.matkhaumoi") || "Nhập mật khẩu mới"}
              control={control}
              borderRadius="12px"
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box className={classes.fieldGroup}>
            <Typography className={classes.formLabel}>
              <SecurityIcon style={{ fontSize: 18, color: "#4F46E5" }} />
              {t("profile.nhaplaimatkhaumoi") || "XÁC NHẬN MẬT KHẨU MỚI"}
            </Typography>
            <InputField
              name="confirmNewPassword"
              inputType="password"
              label={t("profile.nhaplaimatkhaumoi") || "Nhập lại mật khẩu mới"}
              control={control}
              borderRadius="12px"
            />
          </Box>
        </Grid>
      </Grid>

      <Box textAlign="right" mt={2}>
        <Button
          disabled={disabledSubmit}
          type="submit"
          variant="contained"
          className={classes.btnSubmit}
        >
          {t("button.update") ? t("button.update").toUpperCase() : "CẬP NHẬT MẬT KHẨU"}
        </Button>
      </Box>
    </form>
  );
}
